<template>
  <div class="questionnaire-paper" :class="{'error': questionnaireDestory}">
    <template v-if="dataDone && !questionnaireDestory">
      <page-progress />
      <div class="questionnaire-item">
        <div class="qusetion-title"><span class="required">症状变化</span></div>
        <div class="anwser">
          <textarea class="questionnaire-text" v-model="change" placeholder="上次治疗后，最主要症状的变化，比如疾病发作的位置、范围、性质、程度、频率等的变化" maxlength="100"></textarea>
          <span class="limit">{{change.length}}/100</span>
        </div>
      </div>
      <div class="questionnaire-item">
        <div class="qusetion-title"><span>疗法反馈</span></div>
        <div class="anwser">
          <textarea class="questionnaire-text" v-model="feedback" v-ios-bug-fixed placeholder="请对上次用药效果做出评价" maxlength="100"></textarea>
          <span class="limit">{{feedback.length}}/100</span>
        </div>
      </div>
      <div class="questionnaire-item selector" @click="relieveShow = true">
        <div class="qusetion-title"><span>是否得到缓解</span></div>
        <div class="anwser">
          <div class="selector-tips" v-if="!relieve">请选择<icon icon-class="arrow" /></div>
          <div class="selector-value" v-else>{{this.relieve}}</div>
        </div>
      </div>
      <div class="questionnaire-item">
        <div class="qusetion-title"><span>诱发或加重的因素</span></div>
        <div class="anwser">
          <textarea class="questionnaire-text" v-model="exacerbated" v-ios-bug-fixed placeholder="请如实填写" maxlength="100"></textarea>
          <span class="limit">{{exacerbated.length}}/100</span>
        </div>
      </div>
      <div class="questionnaire-item">
        <div class="qusetion-title"><span>缓解的因素</span></div>
        <div class="anwser">
          <textarea class="questionnaire-text" v-model="ease" v-ios-bug-fixed placeholder="请如实填写" maxlength="100"></textarea>
          <span class="limit">{{ease.length}}/100</span>
        </div>
      </div>
      <div class="questionnaire-item">
        <div class="qusetion-title"><span>其他不舒服或希望治疗的症状</span></div>
        <div class="anwser">
          <textarea class="questionnaire-text" v-model="uncomfortable" v-ios-bug-fixed placeholder="上次治疗后，是否有其他不舒服或希望治疗的症状？如有请说明" maxlength="100"></textarea>
          <span class="limit">{{uncomfortable.length}}/100</span>
        </div>
      </div>
      <div class="separate"></div>
      <div class="questionnaire-item">
        <div class="qusetion-title"><span class="required">现病史</span></div>
        <div class="question-tips">简要描述就诊过的医疗机构，进行的辅助检查及结果，接受的治疗手段及治疗效果。发病以来的精神状态、睡眠、饮食、大小便、体重等情况</div>
        <div class="anwser">
          <textarea class="questionnaire-text" v-model="sickNow" v-ios-bug-fixed placeholder="请如实填写" maxlength="100"></textarea>
          <span class="limit">{{sickNow.length}}/100</span>
        </div>
      </div>
      <div class="questionnaire-item">
        <div class="qusetion-title"><span class="required">既往病史</span></div>
        <div class="anwser">
          <textarea class="questionnaire-text" v-model="sickPast" v-ios-bug-fixed placeholder="是否患有其他系统重大疾病或慢性疾病；是否有过重大外伤、手术，若没有请填“无”" maxlength="100"></textarea>
          <span class="limit">{{sickPast.length}}/100</span>
        </div>
        <div class="quick-selector">
          <div class="quick-item" v-for="item in pastData" @click="quickInput('sickPast', item)">{{item}}</div>
        </div>
      </div>
      <div class="separate"></div>
      <div class="questionnaire-item">
        <div class="qusetion-title"><span class="required">过敏史</span></div>
        <div class="anwser">
          <textarea class="questionnaire-text" v-model="allergy" v-ios-bug-fixed placeholder="是否患有其他系统重大疾病或慢性疾病；是否有过重大外伤、手术，若没有请填“无”" maxlength="100"></textarea>
          <span class="limit">{{allergy.length}}/100</span>
        </div>
        <div class="quick-selector">
          <div class="quick-item" v-for="item in allergyData" @click="quickInput('allergy', item)">{{item}}</div>
        </div>
      </div>
      <div class="separate"></div>
      <div class="questionnaire-item">
        <div class="qusetion-title"><span class="required">个人史</span></div>
        <div class="question-tips">出生地及长期居留地。有无烟酒嗜好，若有，请描述平均每日吸烟数或饮酒种类及饮酒量。简要描述职业与工作条件，有无工业毒物、粉尘、放射性物质接触史</div>
        <div class="anwser">
          <textarea class="questionnaire-text" v-model="personal" v-ios-bug-fixed placeholder="请如实填写" maxlength="100"></textarea>
          <span class="limit">{{personal.length}}/100</span>
        </div>
      </div>
      <div class="questionnaire-item">
        <div class="qusetion-title"><span class="required">婚育史</span></div>
        <div class="anwser">
          <textarea class="questionnaire-text" v-model="marry" v-ios-bug-fixed placeholder="婚姻状况、结婚年龄、配偶健康状况、子女数目及其健康状况" maxlength="100"></textarea>
          <span class="limit">{{marry.length}}/100</span>
        </div>
      </div>
      <div class="questionnaire-item">
        <div class="qusetion-title"><span class="required">家族史</span></div>
        <div class="anwser">
          <textarea class="questionnaire-text" v-model="family" v-ios-bug-fixed placeholder="父母、兄弟姐妹的健康状况，有无与患者类似的疾病，有无家族遗传倾向的疾病，若没有请填“无”" maxlength="100"></textarea>
          <span class="limit">{{family.length}}/100</span>
        </div>
        <div class="quick-selector">
          <div class="quick-item" v-for="item in familyData" @click="quickInput('family', item)">{{item}}</div>
        </div>
      </div>
      <div class="separate"></div>
      <div class="questionnaire-item between">
        <div class="type">体温 (℃)</div>
        <div class="content"><input class="number-input" type="number" v-ios-bug-fixed v-model="bodyTemperature" placeholder="请输入"></div>
      </div>
      <div class="questionnaire-item between">
        <div class="type">心率 (次/分)</div>
        <div class="content"><input class="number-input" type="number" v-ios-bug-fixed v-model="heartRate" placeholder="请输入"></div>
      </div>
      <div class="questionnaire-item between">
        <div class="type">每分钟呼吸数 (次/分)</div>
        <div class="content"><input class="number-input" type="number" v-ios-bug-fixed v-model="breath" placeholder="请输入"></div>
      </div>
      <div class="questionnaire-item between">
        <div class="type">血压 (mmHg)</div>
        <div class="content">
          <input type="number" class="number-input small" v-ios-bug-fixed v-model="bloodPressureShrink" placeholder="收缩压">
          <span>/</span>
          <input type="number" class="number-input small" v-ios-bug-fixed v-model="bloodPressureExpand" placeholder="舒张压">
        </div>
      </div>
      <div class="questionnaire-item">
        <div class="qusetion-title"><span>上传面象及病患处照片</span><em>最多上传9张</em></div>
        <div class="anwser">
          <div class="upload-wrapper">
            <div class="upload-item" v-for="(item, index) in faceImgList">
              <span class="delPic" v-if="item.status == 5" @click="delPic(item, 'faceImgList', 'faceOssList')"><icon icon-class="close"></icon></span>
              <div class="preview-box">
                <img :src="item.previewImage" alt="">
                <div class="image-status" v-if="item.status != 5">上传中</div>
              </div>
            </div>
            <div class="upload-item uploader" v-show="faceImgList.length < 9">
              <div class="uploader-box" id="faceUploader">
                <icon icon-class="upload-thin"></icon>
              </div>
            </div>
          </div>
          <div class="upload-tips">
            <p>请使用后置摄像头并关闭美颜功能，每次复诊时请尽量在相同的光源环境下拍摄以避免环境差异造成的影响。</p>
            <p>拍照前请不要化妆。</p>
            <p>请面向自然光线拍照。</p>
          </div>
        </div>
      </div>
      <div class="questionnaire-item">
        <div class="qusetion-title"><span>上传新的检查结果及报告</span><em>最多上传9张</em></div>
        <div class="anwser">
          <div class="upload-wrapper">
            <div class="upload-item" v-for="(item, index) in reportImgList">
              <span class="delPic" v-if="item.status == 5" @click="delPic(item, 'reportImgList', 'reportOssList')"><icon icon-class="close"></icon></span>
              <div class="preview-box">
                <img :src="item.previewImage" alt="">
                <div class="image-status" v-if="item.status != 5">上传中</div>
              </div>
            </div>
            <div class="upload-item uploader" v-show="reportImgList.length < 9">
              <div class="uploader-box" id="reportUploader">
                <icon icon-class="upload-thin"></icon>
              </div>
            </div>
          </div>
          <div class="upload-tips">
            <p>发病以来相关报告均可上传，此次复诊前新做的检查请务必上传</p>
          </div>
        </div>
      </div>
      <div class="next-wrapper">
        <button class="next-button" v-if="isGyn" @click="nextStep">下一步</button>
        <button class="next-button" v-else @click="submitQuestion">发送给医生</button>
      </div>
      <!-- 是否缓解 -->
      <van-popup v-model="relieveShow" position="bottom">
        <van-picker
          show-toolbar
          :columns="relieveData"
          value-key="label"
          @cancel="relieveShow = false"
          @confirm="confirmRelieve"
        />
      </van-popup>
      <x-dialog v-if="questionnaireConfirm" title="是否确认发给医生" @close="questionnaireConfirm = false">
        <div class="content-wrapper">
          <div class="content-text">
            <p>问诊单发送给医生后将无法修改，<br>请仔细检查后再发送哦！</p>
          </div>
          <div class="confirm-control">
            <button class="cancel" @click="questionnaireConfirm = false">取消</button>
            <button class="confirm" @click="sendQuestionnaire" :disabled="sending">确认发送给医生</button>
          </div>
        </div>
      </x-dialog>
    </template>
    <div class="error-page questionnaire" v-if="dataDone && questionnaireDestory">
      <icon icon-class="fail"></icon>
      <p>问诊单不存在</p>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .questionnaire-paper{
    position: relative;
    z-index: 15;
    padding: 32px 16px 0;
    &.error{
      margin-top: -92px;
    }
    .questionnaire-item{
      margin-bottom: 40px;
      &.selector{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .anwser{
          margin-top: 0;
          .selector-tips{
            font-size: 16px;
            line-height: 16px;
            color: #999;
            svg{
              color: #CCC;
            }
          }
          .selector-value{
            font-size: 16px;
            line-height: 16px;
            color: #333;
          }
        }
      }
      .qusetion-title{
        font-size: 16px;
        line-height: 16px;
        color: #666;
        font-weight: bold;
        .required{
          position: relative;
          &::after{
            content: '*';
            position: absolute;
            left: 100%;
            top: 0;
            margin-left: 2px;
            font-size: 16px;
            color: @error;
          }
        }
        em{
          margin-left: 8px;
          font-size: 14px;
          color: #999;
        }
      }
      .question-tips{
        margin-top: 12px;
        padding: 12px;
        background: #FAFAFA;
        font-size: 13px;
        line-height: 19px;
        color: #666;
        border-radius: 4px;
      }
      .anwser{
        margin-top: 12px;
        position: relative;
        .questionnaire-text{
          border: 1px solid #F7F7F7;
          background: #F7F7F7;
          resize: none;
          padding: 12px;
          font-size: 14px;
          line-height: 20px;
          color: #666;
          width: 100%;
          height: 96px;
          &::-webkit-input-placeholder{
            color: #999;
          }
        }
        .limit{
          position: absolute;
          right: 10px;
          bottom: 10px;
          font-size: 12px;
          color: #999;
        }
        .upload-wrapper{
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-wrap: wrap;
          margin-bottom: -16px;
          .upload-item{
            position: relative;
            width: 96px;
            height: 96px;
            margin: 0 16px 16px 0;
            &:nth-child(3n){
              margin-right: 0
            }
            &.uploader{
              .uploader-box{
                width: 100%;
                height: 100%;
                border: 1px dashed #CCC;
                background: #F3F3F3;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                border-radius: 4px;
                svg{
                  font-size: 28px;
                  color: #CCC;
                }
                span{
                  font-size: 12px;
                  line-height: 12px;
                  margin-top: 8px;
                  color: #CCC;
                }
              }
              .preview-box{
                position: relative;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                // width: 156px;
                width: 100%;
                height: 96px;
                border-radius: 4px;
                overflow: hidden;
                img{
                  width: 100%;
                }
                .upload-status{
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  width: 100%;
                  height: 24px;
                  color: #FFF;
                  font-size: 12px;
                  line-height: 24px;
                  text-align: center;
                  background: rgba(0, 0, 0, .4);
                  transition: all .2s;
                  &.done{
                    background: @xile;
                  }
                }
              }
            }
            .preview-box{
              position: relative;
              width: 100%;
              height: 100%;
              overflow: hidden;
              display: flex;
              justify-content: center;
              align-items: center;
              overflow: hidden;
              border-radius: 4px;
              background: #000;
              img{
                width: 100%;
              }
              .image-status{
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 20px;
                line-height: 20px;
                background: rgba(0, 0, 0, .5);
                color: #FFF;
                text-align: center;
                font-size: 12px;
              }
            }
            .delPic{
              position: absolute;
              top: -8px;
              right: -8px;
              width: 20px;
              height: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #DDD;
              border-radius: 50%;
              background: #FFF;
              z-index: 20;
              svg{
                font-size: 12px;
                color: #999;
              }
            }
          }
        }
        .upload-tips{
          margin-top: 16px;
          padding: 12px;
          font-size: 12px;
          line-height: 16px;
          color: #666;
          border: 1px solid #F7F7F7;
          background: #FAFAFA;
          border-radius: 4px;
          p{
            margin-bottom: 8px;
            &:last-child{
              margin-bottom: 0;
            }
          }
        }
      }
      .quick-selector{
        padding-top: 8px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        .quick-item{
          margin: 12px 12px 0 0;
          background: #FAFAFA;
          font-size: 14px;
          line-height: 14px;
          color: #666;
          padding: 11px 12px;
          height: 36px;
          border-radius: 4px;
        }
      }
      &.between{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .type{
          flex-shrink: 0;
        }
        .content{
          display: flex;
          justify-content: flex-end;
          .number-input{
            width: 50%;
            text-align: right;
            font-size: 15px;
            &.small{
              width: 55px;
              text-align: right;
              &:first-child{
                width: 60px;
                padding-right: 11px;
              }
            }
          }
        }
      }
    }
    .separate{
      width: calc(100% + 32px);
      background: #F7F7F7;
      height: 12px;
      margin: 0 -16px 32px -16px;
    }
    .next-wrapper{
      padding: 24px 24px 12px;
      background: #F7F7F7;
      margin: 0 -16px;
      .next-button{
        @button-base();
        width: 100%;
        height: 40px;
      }
    }
    .content-wrapper{
      padding: 40px 0 32px;
      text-align: center;
      .content-text{
        font-size: 14px;
        line-height: 22px;
        font-weight: normal;
        color: @black;
      }
      .confirm-control{
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 120px;
          font-weight: normal;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 15px;
          }
          &.confirm{
            width: 152px;
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import pageProgress from '@/components/Common/pageScrollProgress'
  import xDialog from '@/components/Common/dialog'
  export default {
    data() {
      return {
        dataDone: false,
        questionnaireDestory: false,
        questionnaireId: this.$route.query.id,
        // 是否为妇科问诊单
        isGyn: false,
        // 变化
        change: '',
        // 反馈
        feedback: '',
        // 缓解
        relieve: '',
        relieveData: ['是', '否'],
        relieveShow: false,
        // 加重
        exacerbated: '',
        // 缓解原因
        ease: '',
        // 不舒服
        uncomfortable: '',
        // 现病
        sickNow: '',
        // 既往病
        sickPast: '',
        // 过敏
        allergy: '',
        // 个人
        personal: '',
        // 婚育
        marry: '',
        // 家族
        family: '',
        // 体温
        bodyTemperature: null,
        // 心率
        heartRate: null,
        breath: null,
        // 血压
        bloodPressureShrink: null,
        bloodPressureExpand: null,


        // 既往病史
        pastData: ['无', '高血压病', '高脂血症', '糖尿病', '冠心病', '心律失常', '心肌梗塞', '心力衰竭', '脑梗死', '脑出血', '慢性支气管炎', '慢性阻塞性肺疾病', '肺源性心脏病', '支气管哮喘', '支气管扩张症', '消化道溃疡', '反流性食管炎', '胆结石', '脂肪肝', '肝硬化', '慢性肾小球肾炎', '肾病综合征', '肾功能衰竭', '甲状腺功能亢进症', '甲状腺功能减退症', '痛风', '帕金森病', '乙型病毒性肝炎', '结核病', '重大外伤史', '重大手术史', '输血史'],
        // 过敏史
        allergyData: ['无', '青霉素', '链霉素', '头孢类', '磺胺类', '普鲁卡因', '酒精', '花粉', '柳絮', '粉尘', '动物皮屑', '螨虫', '鸡蛋', '牛奶', '鱼虾', '海鲜', '牛羊肉', '花生', '甲醛', '油漆', '冷空气', '热空气'],
        // 家族史
        familyData: ['无', '猫叫综合征', '21三体综合征', '软骨发育不全', '多指症', '结肠息肉', '白化病', '先天性聋哑', '高度近视', '红绿色盲', '血友病', '原发性高血压', '支气管哮喘', '冠心病', '青少年型糖尿病', '类风湿性关节炎', '精神分裂症', '癫痫', '先天性心脏病', '消化性溃疡', '抑郁症', '阿尔茨海默病', '肥胖', '恶性肿瘤'],

        // 上传面像
        faceUploader: null,
        faceImgList: [],
        faceOssList: [],
        // 上传检查报告
        reportUploader: null,
        reportImgList: [],
        reportOssList: [],
        questionnaireConfirm: false,
        sending: false,
        postData: {},
      }
    },
    components: {
      pageProgress,
      xDialog
    },
    created() {
      this.dataDone = true;
      // 获取是否要显示妇科问诊内容
      this.$root.post('/isGyn', {
        id: this.questionnaireId
      }).then(data => {
        this.isGyn = data ? true : false;
      })
      // 获取数据回显
      this.$root.post('/getAnswerDetail', {
        type: 2,
        id: this.questionnaireId
      }).then(data => {
        if(data.status == 1) {
          console.log(data);
          // 回显数据
          for(let item in data.second) {
            this[item] = data.second[item];
          }
          this.change = data.sym_change || '';
          this.relieve = data.second ? (data.second.relieve == 3 || !data.second.relieve) ? '' : (data.second.relieve == 1 ? '是' : '否') : '';
          this.faceOssList = data.second ? (data.second.face_img || []) : [];
          this.reportOssList = data.second ? (data.second.result_img || []) : [];
          if(this.faceOssList.length > 0) {
            this.faceOssList.forEach(item => {
              this.faceImgList.push({
                previewImage: item,
                status: 5
              })
            })
          }
          if(this.reportOssList.length > 0) {
            this.reportOssList.forEach(item => {
              this.reportImgList.push({
                previewImage: item,
                status: 5
              })
            })
          }
          // 初始化图片上传
          this.$nextTick(() => {
            // 多张上传
            this.setMultipleUpload(this.faceUploader, 'faceUploader', 'faceImgList', 'faceOssList');
            this.setMultipleUpload(this.reportUploader, 'reportUploader', 'reportImgList', 'reportOssList');
          })
        }else if(data.status == 2) {
          // 问诊单已被删除
          this.dataDone = true;
          this.questionnaireDestory = true;
        }else if(data.status == 0) {
          // 已完成的问诊单
          this.$router.replace({path: '/patient/record/detail', query: {type: 2, id: this.questionnaireId}});
        }
      })
    },
    methods: {
      // 上传多张张函数
      setMultipleUpload(obj, id, file, finalList) {
        let _this = this;
        obj = new plupload.Uploader({
          runtimes: 'html5,flash,silverlight,html4',
          browse_button: id,
          flash_swf_url: '/view/index/template/src/assets/js/plupload/js/Moxie.swf',
          silverlight_xap_url: '/view/index/template/src/assets/js/plupload/js/Moxie.xap',
          url: 'http://oss.aliyuncs.com',
          // 不检测重复文件
          filters: {},
          // 多文件上传
          multi_selection: true,
          init: {
            // 选择文件之后
            FilesAdded(up, files) {
              // 获取当前已上传的图片数量
              let objLength = _this[file].length;
              let canUploadFiles = 0
              files.forEach(item => {
                // 如果本次选中的图片数量超出了9张的限制，则自动删除多出的图片
                if(item.type.indexOf("image/") == -1) {
                  _this.$notify('图片格式不正确');
                  up.removeFile(item)
                  return false;
                }else {
                  objLength++;
                  canUploadFiles++;
                  if(objLength > 9) {
                    up.removeFile(item);
                  };
                  let fileName = item.name;
                  _this.$root.previewUploadImage(item, (imgSrc) => {
                    item.previewImage = imgSrc;
                    _this[file].push(item);
                  })
                }
              })
              if(canUploadFiles == files.length) {
                _this.$root.setUploadParam(up, '', false, 'patient');
              }
            },
            // 上传前设置文件名
            BeforeUpload(up, fileObj) {
              _this.$root.setUploadParam(up, fileObj.name, true, 'patient');
            },
            // 上传完成
            FileUploaded(up, fileObj, info) {
              if(info.status == 200) {
                let res = JSON.parse(info.response);
                _this[finalList].push(res.path)
              }
            },
            Error(up, err) {
              console.log(err);
            }
          }
        })
        // 初始化上传
        obj.init();
      },
      // 确认是否缓解
      confirmRelieve(value) {
        this.relieve = value;
        this.relieveShow = false;
      },
      // 删除已上传的图片
      delPic(item, obj, ossObj) {
        let index = this[obj].indexOf(item)
        this[obj].splice(index, 1);
        this[ossObj].splice(index, 1);
      },
      // 快速选择选项
      quickInput(type, item) {
        // 字数即将大于最大值时取消操作
        let text = this[type] + `，${item}`;
        if(text.length >= 100) return;
        if(this[type]) {
          this[type] += `，${item}`;
        }else {
          this[type] = item;
        }
      },
      beforeSubmitAction(cb) {
        if(!this.change) {this.$notify('请填写症状变化');return false;}
        if(!this.sickNow) {this.$notify('请填写现病史');return false;}
        if(!this.sickPast) {this.$notify('请填写既往病史');return false;}
        if(!this.allergy) {this.$notify('请填写过敏史');return false;}
        if(!this.personal) {this.$notify('请填写个人史');return false;}
        if(!this.marry) {this.$notify('请填写婚育史');return false;}
        if(!this.family) {this.$notify('请填写家族史');return false;}

        this.postData = {
          id: this.questionnaireId,
          sym_change: this.change,
          second: {
            feedback: this.feedback,
            relieve: this.relieve ? (this.relieve == '是' ? 1 : 2) : 3,
            uncomfortable: this.uncomfortable,
            exacerbated: this.exacerbated,
            ease: this.ease,
            sickNow: this.sickNow,
            sickPast: this.sickPast,
            allergy: this.allergy,
            personal: this.personal,
            marry: this.marry,
            family: this.family,
            bodyTemperature: this.bodyTemperature,
            heartRate: this.heartRate,
            breath: this.breath,
            bloodPressureShrink: this.bloodPressureShrink,
            bloodPressureExpand: this.bloodPressureExpand,
            face_img: this.faceOssList || '',
            result_img: this.reportOssList || ''
          }
        }
        if(cb) cb();
      },
      // 下一步
      nextStep() {
        this.beforeSubmitAction(() => {
          console.log('111');
          this.$root.post('/addPatientAnswer', this.postData).then(data => {
            console.log(data);
            if(data.status == 1) {
              this.$router.push({path: '/patient/questionnaire/westenFemale', query: {id: this.questionnaireId}});
            }else {
              this.$notify(data.msg);
            }
          })
        });

      },
      // 提交
      submitQuestion() {
        this.beforeSubmitAction(() => {
          console.log(this.postData);
          this.questionnaireConfirm = true;
        });
      },
      sendQuestionnaire() {
        this.sending = true;
        this.$root.post('/addPatientAnswer', {
          id: this.questionnaireId,
          status: 2,
          sym_change: this.change,
          second: this.postData.second
        }).then(data => {
          this.sending = false;
          if(data.status == 1) {
            let _this = this;
            // 发送自定义的问诊单卡片
            let conversationType = RongIMLib.ConversationType.PRIVATE;
            // 获取targetId
            let targetId = data.info.doc_id.toString();
            let msg = new RongIMClient.RegisterMessage.AnswerMessage({
              username: data.info.username,
              sym_change: data.info.sym_change,
              create_time: data.info.create_time,
              birthday: data.info.birthday,
              gender: data.info.gender,
              id: data.info.id,
            })
            RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
              onSuccess: function (message) {
                _this.$notify({
                  background: '#00848A',
                  message: '成功发送给医生'
                });
                _this.questionnaireConfirm = false;
                _this.$router.push('/patient');
              },
              onError: function (errorCode) {
                console.log('发送自定义消息失败', errorCode);
              }
            })
          }else {
            this.$notify(data.msg);
          }
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/Questionnaire/westenQuestionnaire.vue